/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import '../../css/event210621.css';

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import axios from "axios";

class ContentItem4 extends PureComponent {
  state = {
    alram: 100,
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.reset !== nextProps.childProps.reset;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)

    if (this.props.childProps.reset !== nextProps.childProps.reset) {
      this.setState({
        alram: 100,
      });
    }
  };

  _onExpect = async () => {
    const { contentSerial, img, title, alramFlag, _expect, grade } =
      this.props.childProps;

    const a = await _expect(contentSerial, img, title, alramFlag, grade);
    //console.log(a)
    //if(parseInt(a) === 100) {
    this.setState({
      alram: parseInt(a),
    });
    //}
  };
  _onExpectApi = () => {};
  _CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  render() {
    const { contentSerial, img, comment, title, grade } = this.props.childProps;
    const { imgUrl } = this.props;
    const { alram } = this.state;
    return (
      <Fragment>
        {alram === 0 ? (
          <li>
            <div className="item">
              <div className="point">
                <span>현상금: {this._CommaFormatted(grade)} AP</span>
              </div>
              <div className="thumb">
                <a href="#">
                  <img src={imgUrl + '/img/event/event220316/item_img.png'} />
                </a>
              </div>
              {/*
                            <div className="info">
                                <p className="date">
                                    <img src="/img/event/event220316/ico_live.png" alt="LIVE"/> 04/14 첫방송
                                </p>
                                <p className="subject">
                                    <a href="#">치트 약사의 슬로우 라이프~이세계에 만들자 드러그 스토어~</a>
                                </p>
                            </div>
                            */}
              <button
                type="button"
                className="btnAlram"
                onClick={this._onExpect}
              >
                타깃지정
              </button>
            </div>
          </li>
        ) : (
          /*
                     <li>
                         <div className="item">
                            <div className="thumb"><a onClick={this._onExpect} style={{ cursor: 'pointer'}}><img src=""/>ANIPLUS {grade}</a></div>
                         </div>
                     </li>
                    */
          <li>
            <div className="item active">
              <div className="point">
                <span>현상금: {this._CommaFormatted(grade)} AP</span>
              </div>
              <div className="thumb" style={{ textAlign: 'center' }}>
                <a
                  onClick={() => this._goContent(contentSerial)}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={img} />
                </a>
              </div>
              <div className="info">
                <p className="date">
                  <img
                    src={imgUrl + '/img/event/event220316/ico_live.png'}
                    alt="LIVE"
                  />{' '}
                  {comment}
                </p>
                <p className="subject">
                  <a
                    onClick={() => this._goContent(contentSerial)}
                    style={{ cursor: 'pointer' }}
                  >
                    {title}
                  </a>
                </p>
              </div>
              <button type="button" className="btnAlram">
                타깃지정
              </button>
            </div>
          </li>
          /*
                    <li>
                        <div className="item">
                            <div className="thumb"><a onClick={()=>this._goContent(contentSerial)} style={{ cursor: 'pointer'}}><img src={img}/></a></div>
                            <div className="info">
                                <p className="date">
                                    <img src="/img/event/event211217/ico_live.png" alt="LIVE"/> {comment}
                                </p>
                                <p className="subject">
                                    <a onClick={()=>this._goContent(contentSerial)} style={{ cursor: 'pointer'}}>{title}</a>
                                </p>
                            </div>
                            <button type="button" className={"btnAlram active"} >타깃지정</button>
                        </div>
                    </li>
                    */
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ContentItem4));
